<template><div class="input-group-prepend"><slot /></div></template>
<script>export default { name: "SbInputGroupPrepend" };</script>
